// Company
const COMPANY_NAME = 'SCP Health'
const COMPANY_SHORT_NAME = 'SCP'

// Site
const SITE_NAME = 'mySCP'

export {
  COMPANY_NAME,
  COMPANY_SHORT_NAME,
  SITE_NAME
}
